import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async store(projectId: Id, packageId: Id, data: ApiRequests['api.v1.scope-gaps.store']) {
    return await api(route('api.v1.scope-gaps.store', { project: projectId, package: packageId }), 'post', {
      data,
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.scope-gaps.show', id), 'get');
  },
};
